<template>
    <div class="order-page" :class="{ 'order-page--mobile': ebkMobile }">
        <page-breadcrumb :items="pageBreadcrumbItems" :mobile="ebkMobile" />
        <!-- 筛选：桌面 -->
        <div v-show="!ebkMobile" class="row ai-c wrap filter-toolbar" data-ebk-guide="order-filter">
            <span class="fc-sub">订单状态：</span>
            <el-select
                v-model="dataForm.order_status"
                class="hundred"
                size="small"
                placeholder="请选择"
                filterable
            >
                <el-option
                    v-for="item in statusData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
            </el-select>
            <span class="fc-sub ml-3">下单时间：</span>
            <el-date-picker
                v-model="addTime"
                type="daterange"
                :unlink-panels="ebkMobile"
                size="small"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            >
            </el-date-picker>
            <span class="fc-sub ml-3">酒店名称：</span>
            <el-input
                placeholder="请输入酒店名称"
                v-model="dataForm.res_name"
                size="small"
                clearable
                class="hundreded"
            ></el-input>
            <span class="fc-sub ml-3">单据号：</span>
            <el-input
                placeholder="请输入单据号"
                v-model="dataForm.order_no"
                size="small"
                clearable
                class="hundreded"
            ></el-input>
            <span class="fc-sub ml-3">联系电话：</span>
            <el-input
                placeholder="请输入入住人联系电话"
                v-model="dataForm.contact_mobile"
                size="small"
                clearable
                class="hundreded"
            ></el-input>
            <el-button
                type="primary"
                icon="el-icon-search"
                class="ml-3 pl-3"
                data-ebk-guide="order-search"
                @click="changeStatus"
                size="small"
                >查询</el-button
            >
        </div>

        <!-- 筛选：移动端 -->
        <div v-show="ebkMobile" class="order-m-filters" data-ebk-guide="order-filter">
            <el-collapse v-model="orderMobileFilterActive" accordion>
                <el-collapse-item title="筛选条件" name="filter">
                    <div class="order-m-fields">
                        <div class="order-m-field">
                            <span class="order-m-label">订单状态</span>
                            <el-select
                                v-model="dataForm.order_status"
                                class="order-m-control"
                                size="small"
                                placeholder="请选择"
                                filterable
                            >
                                <el-option
                                    v-for="item in statusData"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="order-m-field">
                            <span class="order-m-label">下单时间</span>
                            <el-date-picker
                                v-model="addTime"
                                class="order-m-control"
                                type="daterange"
                                :unlink-panels="ebkMobile"
                                size="small"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                            >
                            </el-date-picker>
                        </div>
                        <div class="order-m-field">
                            <span class="order-m-label">酒店名称</span>
                            <el-input
                                placeholder="请输入酒店名称"
                                v-model="dataForm.res_name"
                                size="small"
                                clearable
                                class="order-m-control"
                            ></el-input>
                        </div>
                        <div class="order-m-field">
                            <span class="order-m-label">单据号</span>
                            <el-input
                                placeholder="请输入单据号"
                                v-model="dataForm.order_no"
                                size="small"
                                clearable
                                class="order-m-control"
                            ></el-input>
                        </div>
                        <div class="order-m-field">
                            <span class="order-m-label">联系电话</span>
                            <el-input
                                placeholder="入住人联系电话"
                                v-model="dataForm.contact_mobile"
                                size="small"
                                clearable
                                class="order-m-control"
                            ></el-input>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                class="order-m-search-btn"
                data-ebk-guide="order-search"
                @click="changeStatus"
                >查询</el-button
            >
        </div>

        <div v-show="!ebkMobile" class="table-scroll-x">
        <el-table
            :data="tableData"
            stripe
            size="small"
            style="width: 100%"
            class="mt-3 pt-3"
            highlight-current-row
            data-ebk-guide="order-table"
        >
            <el-table-column prop="order_no" label="订单号">
                <template slot-scope="scope">
                    <span class="fc-m">{{scope.row.order_no}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="订单状态" width="120px">
                <template slot-scope="scope">
                    <span class="fc-wan" v-if="scope.row.order_status == 1">待确认</span>
                    <span class="fc-s" v-if="scope.row.order_status == 2">已确认</span>
                    <span class="fc-e" v-if="scope.row.order_status == 3">确认失败</span>
                    <span class="fc-g" v-if="scope.row.order_status == 4">已取消</span>
                    <span v-if="scope.row.order_status == 5">取消中</span>
                    <span class="fc-wa" v-if="scope.row.order_status == 6 || scope.row.order_status == -1">待支付</span>
                </template>
            </el-table-column>
            <el-table-column prop="res_name" label="酒店名称"></el-table-column>
            <el-table-column prop="" label="入离时间">
                <template slot-scope="scope">
                    <div class="fz-3">
                        {{ timestampToTime(scope.row.check_in_date) }}至
                    </div>
                    <div class="fz-3">
                        {{ timestampToTime(scope.row.check_out_date) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="house_type_name" label="房型/产品/早餐">
                <template slot-scope="scope">
                    <span class="fz-3">{{ scope.row.house_type_name }}</span
                    >/ <span class="fz-3">{{ scope.row.policy_name }}</span
                    >/
                    <span class="fz-3" v-if="scope.row.breakfast_count == 0"
                        >无早</span
                    >
                    <span
                        class="fz-3"
                        v-else-if="scope.row.breakfast_count == 1"
                        >单早</span
                    >
                    <span
                        class="fz-3"
                        v-else-if="scope.row.breakfast_count == 2"
                        >双早</span
                    >
                    <span
                        class="fz-3"
                        v-else-if="scope.row.breakfast_count == 3"
                        >三份早餐</span
                    >
                    <span class="fz-3" v-else>含早</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="psg_name"
                label="入住人"
                width="120px"
            >
                <template slot-scope="scope">
                    {{ scope.row.psg_name || "—" }}
                </template>
            </el-table-column>
            <el-table-column prop="add_time" label="下单时间"></el-table-column>
            <el-table-column
                prop="res_phone"
                label="酒店联系电话"
            ></el-table-column>

            <el-table-column
                prop=""
                label="金额"
            >
                 <template slot-scope="scope">
                    <span>￥{{scope.row.o_fu_money}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="operate" label="操作">
                <template slot-scope="scope">
                    <span
                        class="fc-m fz-3 cur-p"
                        @click="getOrderDetail(scope.row)"
                        >详情</span
                    >
                </template>
            </el-table-column>
        </el-table>
        </div>

        <!-- 移动端：订单卡片 -->
        <div v-show="ebkMobile" class="order-m-card-list mt-3" data-ebk-guide="order-table">
            <template v-if="!tableData || !tableData.length">
                <div class="order-m-empty">暂无订单数据</div>
            </template>
            <template v-else>
                <div
                    v-for="(row, idx) in tableData"
                    :key="orderRowKey(row, idx)"
                    class="order-m-card"
                    @click="getOrderDetail(row)"
                >
                <div class="order-m-card__head">
                    <span class="order-m-card__no">{{ row.order_no || "—" }}</span>
                    <span
                        class="order-m-card__status"
                        :class="orderStatusDisplay(row.order_status).cls"
                        >{{ orderStatusDisplay(row.order_status).text }}</span
                    >
                </div>
                <div class="order-m-card__hotel">{{ row.res_name || "—" }}</div>
                <div class="order-m-card__row">
                    <span class="order-m-card__k">入离</span>
                    <span class="order-m-card__v">
                        {{ timestampToTime(row.check_in_date) }} 至
                        {{ timestampToTime(row.check_out_date) }}
                    </span>
                </div>
                <div class="order-m-card__row">
                    <span class="order-m-card__k">房型</span>
                    <span class="order-m-card__v order-m-card__product">
                        {{ row.house_type_name || "—" }}
                        <span class="order-m-card__sep">/</span>
                        {{ row.policy_name || "—" }}
                        <span class="order-m-card__sep">/</span>
                        {{ orderBreakfastLabel(row.breakfast_count) }}
                    </span>
                </div>
                <div class="order-m-card__row order-m-card__row--split">
                    <span class="order-m-card__inline">
                        <span class="order-m-card__k">入住人</span>
                        {{ row.psg_name || "—" }}
                    </span>
                    <span class="order-m-card__inline order-m-card__inline--r">
                        <span class="order-m-card__k">下单</span>
                        {{ row.add_time || "—" }}
                    </span>
                </div>
                <div class="order-m-card__foot">
                    <span class="order-m-card__foot-phone">{{
                        row.res_phone || "—"
                    }}</span>
                    <span class="order-m-card__foot-money"
                        >￥{{ row.o_fu_money }}</span
                    >
                    <span class="order-m-card__foot-link">详情</span>
                </div>
                </div>
            </template>
        </div>

        <div class="mt-3 pt-3 order-pager-wrap" :class="{ 'order-pager-wrap--m': ebkMobile }">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="dataForm.page"
                :page-sizes="[ 10, 15, 20]"
                :page-size="dataForm.limit"
                :layout="ebkMobile ? 'total, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
                :small="ebkMobile"
                :pager-count="ebkMobile ? 5 : 7"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import qs from "qs";
import { Loading } from "element-ui";
import {Message} from 'element-ui';
import mobileBreakpoint from "@/mixins/mobileBreakpoint";
import featureGuideMixin from "@/mixins/featureGuideMixin";
import { GUIDE_IDS } from "@/config/featureGuides";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
var options = {
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
};
export default {
    name: "order",
    components: { PageBreadcrumb },
    mixins: [mobileBreakpoint, featureGuideMixin],
    data() {
        return {
            ebkFeatureGuideId: GUIDE_IDS.order,
            orderMobileFilterActive: "",
            bodyStyle:{
                padding: '10px'
            },
            dataForm: {
                order_status: -1,
                order_no: "",
                dp_id: "",
                sales_channel: "",
                check_in_date: "",
                check_out_date: "",
                s_add_time: "",
                e_add_time: "",
                contact_mobile: "",
                res_name: "",
                policy_name: "",
                page: 1,
                start: 0,
                limit: 10,
                orderType: "1",
                project_code: "",
                cai_notice:0
            },
            statusData: [
                {
                    label: "全部",
                    value: -1,
                },
                {
                    label: "待确认",
                    value: 1,
                },
                {
                    label: "待取消",
                    value: 99,
                },
                {
                    label: "已确认",
                    value: 2,
                },
                {
                    label: "确认失败",
                    value: 3,
                },
                {
                    label: "已取消",
                    value: 4,
                },
                {
                    label: "待支付",
                    value: 6,
                },
            ],
            tableData: [],
            userInfo: {},
            total: 0,
            addTime: [],
            detailVisible: false,
            detail: {},
            logs: [],
            logDialogVisible: false,
        };
    },
    computed: {
        pageBreadcrumbItems() {
            return [
                { label: "工作台", to: { path: "/hotel" } },
                { label: "订单列表" },
            ];
        },
    },
    created() {
        this.getToday();
        this.dataForm.dp_id = this.userInfo.id;
        this.orderList();
    },
    watch: {
        addTime(val) {
            if (val) {
                this.dataForm.s_add_time = val[0];
                this.dataForm.e_add_time = val[1];
            } else {
                this.dataForm.s_add_time = "";
                this.dataForm.e_add_time = "";
            }
        },
    },
    methods: {
        // 获取今日日期
        getToday() {
            this.userInfo = JSON.parse(this.getToken("userInfo"));
            var nowDate = new Date();
            var year = nowDate.getFullYear();
            var month =
                nowDate.getMonth() + 1 < 10
                    ? "0" + (nowDate.getMonth() + 1)
                    : nowDate.getMonth() + 1;
            var day =
                nowDate.getDate() < 10
                    ? "0" + nowDate.getDate()
                    : nowDate.getDate();
            this.addTime = [
                year + "-" + month + "-" + "01",
                year + "-" + month + "-" + day,
            ];
            this.dataForm.s_add_time = this.addTime[0];
            this.dataForm.e_add_time = this.addTime[1];
        },
        // 获取订单列表
        orderList() {
            if (!this.addTime) {
                Message.error('请选择时间范围');
            }
            Loading.service(options);

            let data = JSON.parse(JSON.stringify(this.dataForm))
            if(data.order_status == 99){
                data.order_status = -1;
                data.cai_notice = 1;
            }else{
                data.cai_notice = 0;
            }
            this.$axios
                .sobillList(qs.stringify(data))
                .then((res) => {
                    Loading.service(options).close();
                    this.tableData = res.dataList;
                    this.total = parseInt(res.totalCount);
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
        // 酒店列表更改条数重新请求接口数据
        handleSizeChange(e) {
            this.dataForm.page = 1;
            this.dataForm.start = (this.dataForm.page)*e;
            this.dataForm.limit = e;
            this.orderList();
        },
        // 修改页数
        handleCurrentChange(e) {
            this.dataForm.page = e;
            this.dataForm.start = (e - 1)*this.dataForm.limit;
            this.orderList();
        },
        // 时间戳转化为日期格式
        timestampToTime(timestamp) {
            var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let Y = date.getFullYear() + "-";
            let M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
            let D = date.getDate() + " ";
            return Y + M + D;
        },
        // 详情页按 o_id 实时拉取，不再依赖列表缓存
        getOrderDetail(row) {
            const oId =
                row.o_id != null && row.o_id !== ""
                    ? row.o_id
                    : row.id;
            if (oId == null || oId === "") {
                Message.error("订单缺少主键，无法打开详情");
                return;
            }
            this.$router.push({
                name: "orderDetail",
                query: {
                    o_id: String(oId),
                    _: String(Date.now()),
                },
            });
        },
        orderRowKey(row, idx) {
            var id = row.o_id != null && row.o_id !== "" ? row.o_id : row.id;
            return (
                "order-" +
                (id != null ? id : idx) +
                "-" +
                (row.order_no || "") +
                "-" +
                idx
            );
        },
        orderStatusDisplay(order_status) {
            var s = Number(order_status);
            if (s === 1) return { text: "待确认", cls: "fc-wan" };
            if (s === 2) return { text: "已确认", cls: "fc-s" };
            if (s === 3) return { text: "确认失败", cls: "fc-e" };
            if (s === 4) return { text: "已取消", cls: "fc-g" };
            if (s === 5) return { text: "取消中", cls: "" };
            if (s === 6 || s === -1) return { text: "待支付", cls: "fc-wa" };
            return { text: "—", cls: "" };
        },
        orderBreakfastLabel(breakfast_count) {
            var c = Number(breakfast_count);
            if (c === 0) return "无早";
            if (c === 1) return "单早";
            if (c === 2) return "双早";
            if (c === 3) return "三份早餐";
            if (c === 4) return "四份早餐";
            return "含早";
        },
        changeStatus() {
            this.dataForm.page = 1;
            this.dataForm.start = 0;
            this.orderList();
        },
    },
};
</script>

<style scoped>
.hundred {
    width: 120px;
}
.hundreded {
    width: 150px;
}

.left-w {
    display: inline-block;
    width: 100px;
}
.fz-4 {
    font-size: 16px;
}

.fc-wan{
    color: #E6A23C;
}

.el-date-editor /deep/ .el-range-separator {
    width: 6%;
}

.card>div{
    width: 50%;
}
.border-l{
    border-left: 1px solid #e7dfe1;
}
.border-r{
    border-right: 1px solid #dfe5e7;
}
.border-t{
    border-top: 1px solid #dfe5e7;
}
.border-b{
    border-bottom: 1px solid #dfe5e7;
}
.p-one{
    padding: 5px;
}

/* —— 移动端：折叠筛选 + 订单卡片 —— */
.order-page {
    text-align: left;
}
.order-m-filters {
    margin-bottom: 12px;
}
.order-m-filters /deep/ .el-collapse {
    border: none;
}
.order-m-filters /deep/ .el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    padding-left: 12px;
    font-size: 14px;
    background: #fff;
    border-radius: 8px 8px 0 0;
    border: 1px solid #ebeef5;
    border-bottom: none;
}
.order-m-filters /deep/ .el-collapse-item__wrap {
    border-bottom: none;
}
.order-m-filters /deep/ .el-collapse-item__content {
    padding-bottom: 10px;
    padding-top: 4px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-top: none;
    border-radius: 0 0 8px 8px;
}
.order-m-fields {
    padding: 0 12px 8px;
}
.order-m-field {
    margin-bottom: 12px;
}
.order-m-field:last-child {
    margin-bottom: 4px;
}
.order-m-label {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
}
.order-m-control {
    width: 100% !important;
}
.order-m-search-btn {
    width: 100%;
    margin-top: 10px;
    min-height: 44px;
    margin-left: 0 !important;
    font-size: 14px;
}
.order-m-card-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.order-m-empty {
    text-align: center;
    padding: 24px 12px;
    font-size: 13px;
    color: #909399;
    background: #f5f7fa;
    border-radius: 8px;
    border: 1px dashed #e4e7ed;
}
.order-m-card {
    background: #fff;
    border-radius: 8px;
    padding: 10px 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    border: 1px solid #ebeef5;
    box-sizing: border-box;
    width: 100%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.order-m-card:active {
    background: #fafafa;
}
.order-m-card__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}
.order-m-card__no {
    font-size: 13px;
    font-weight: 600;
    color: #409eff;
    flex: 1;
    min-width: 0;
    word-break: break-all;
    line-height: 1.3;
}
.order-m-card__status {
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
}
.order-m-card__hotel {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 1.35;
    margin-bottom: 6px;
    word-break: break-word;
}
.order-m-card__row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12px;
    line-height: 1.4;
    margin-bottom: 3px;
}
.order-m-card__row--split {
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 0;
}
.order-m-card__k {
    flex-shrink: 0;
    font-size: 12px;
    color: #909399;
    line-height: 1.35;
}
.order-m-card__row > .order-m-card__k {
    width: 2.2em;
}
.order-m-card__v {
    flex: 1;
    min-width: 0;
    font-size: 12px;
    color: #606266;
    line-height: 1.35;
    word-break: break-word;
}
.order-m-card__product {
    font-weight: 500;
    color: #303133;
}
.order-m-card__sep {
    margin: 0 2px;
    color: #c0c4cc;
    font-weight: 400;
}
.order-m-card__inline {
    flex: 1;
    min-width: 0;
    font-size: 12px;
    color: #303133;
    line-height: 1.35;
    word-break: break-word;
}
.order-m-card__inline--r {
    flex: 0 1 auto;
    text-align: right;
    white-space: nowrap;
}
.order-m-card__inline .order-m-card__k {
    margin-right: 4px;
}
.order-m-card__foot {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #f2f3f5;
    font-size: 12px;
    line-height: 1.3;
}
.order-m-card__foot-phone {
    flex: 1;
    min-width: 0;
    color: #606266;
    word-break: break-all;
}
.order-m-card__foot-money {
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 700;
    color: #f56c6c;
}
.order-m-card__foot-link {
    flex-shrink: 0;
    color: #409eff;
    font-weight: 500;
}
.order-pager-wrap {
    text-align: left;
}
.order-pager-wrap--m {
    text-align: center;
}
.order-page--mobile .order-pager-wrap--m /deep/ .el-pagination {
    padding: 8px 0 4px;
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 6px 4px;
    max-width: 100%;
}
.order-page--mobile .order-pager-wrap--m /deep/ .el-pagination > * {
    margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/order.vue